import { DresonRuleResolvedEvent } from "../../types/FilterTypes";
import { replaceNode } from "./Utils";

export default class LoadSeoConsultantText {
  static onLoadSeoConsultantText(data: DresonRuleResolvedEvent): void {
    const seoConsultantTextNode: HTMLElement | null = document.getElementById("reptile-nav-consultant-text");
    if (!seoConsultantTextNode) {
      return;
    }

    const { rule } = seoConsultantTextNode.dataset;
    if (rule === data.rule) {
      return;
    }

    fetch(LoadSeoConsultantText.uri(data.rule))
      .then(LoadSeoConsultantText.extractResponseText)
      .then((html: string) => LoadSeoConsultantText.replaceSeoConsultantText(seoConsultantTextNode, data.rule, html))
      .catch((e: Error) => {
        console.warn(`Filter reload AJAX GET against ${LoadSeoConsultantText.uri(data.rule)} failed: ${e.message}`);
      });
  }

  private static extractResponseText(xhr: Response) {
    if (xhr.status !== 200 && xhr.status !== 204) {
      throw Error(`Failed to retrieve nav consultant: ${xhr.status} ${xhr.statusText}`);
    }
    return xhr.text();
  }

  /**
 *
 *
 *
 *
 */
  private static replaceSeoConsultantText(navConsultantTextNode: HTMLElement, nodeRule: string, newHtml: string) {
    replaceNode(navConsultantTextNode, nodeRule, newHtml);
  }

  private static uri(ruleString: string) {
    return `/scp-bob/page/${encodeURIComponent(ruleString)}/seo-text-product-list.html`;
  }
}
